import React, { InputHTMLAttributes, useId } from 'react';
import { cx } from './cx';

export const inputStatuses = ['default', 'valid', 'invalid'] as const;
export type InputStatus = (typeof inputStatuses)[number];

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  status?: InputStatus;
  message?: string;
}

function statusClass(status: InputStatus): string {
  switch (status) {
    case 'default':
      return '';
    case 'valid':
      return 'osrs-input--valid';
    case 'invalid':
      return 'osrs-input--invalid';
    default: {
      const neverStatus: never = status;
      return neverStatus;
    }
  }
}

const Input: React.FC<InputProps> = ({
  label,
  status = 'default',
  message,
  id,
  className,
  ...props
}) => {
  const autoId = useId();
  const fieldId = id ?? autoId;
  const messageId = message ? `${fieldId}-message` : undefined;

  return (
    <div className="osrs-field">
      {label ? <label htmlFor={fieldId}>{label}</label> : null}
      <input
        id={fieldId}
        className={cx('osrs-input', statusClass(status), className)}
        aria-invalid={status === 'invalid' || undefined}
        aria-describedby={messageId}
        {...props}
      />
      {message ? (
        <span id={messageId} className={`osrs-field__message--${status}`}>
          {message}
        </span>
      ) : null}
    </div>
  );
};

export default Input;
